// Add new row to the form
import applyDiscount from "./applyDiscount";
import {
  disableSubmitButton,
  enableOrDisableSubmitButton,
} from "./validation/enableOrDisableSubmitButton";

const {v4: uuidv4} = require("uuid"); // Generate unique id for new form rows
// Template for a new form row
// Get template content from hidden textarea
const template = jQuery.validator.format($.trim($("#template").val()));

function addRow() {
  $(template(uuidv4())).appendTo(".form__rows");
  disableSubmitButton();
  applyDiscount();
}

// Delete a row from the form
function removeRow(e) {
  const rowToRemove = $(e.target).parents(".form__row");
  $(rowToRemove).remove();
  updateBikeCount();
  enableOrDisableSubmitButton($(".questionsForm"));
  applyDiscount();
}

// add more rows on click
$("#add").click(function (e) {
  e.preventDefault();
  addRow();
  updateBikeCount();
});

// remove the current row
$(document).on("click", ".remove-row", function (e) {
  removeRow(e);
});

// update bike count
function updateBikeCount() {
  $('[name*="bike-count"]').val($(".form__row").length);
}

function updateTotalValue(e) {
    let $totalValueInput = $(".field__box--totalValue input, .totalValue");
    $totalValueInput.val("");
    // console.log(e);
    let totalValue = 0;
    $(".field__box--currency input").each(function () {
        totalValue += Number($(this).val());
    });
    $totalValueInput.val(totalValue);
    $totalValueInput.blur();
}

$(document).on("input change", ".field__box--currency input", function (e) {
    updateTotalValue(e);
});
